import _Scale from "./scale.svg";
import ScaleWithBeaker from "./scale_with_beaker.svg";
import ScaleWithBeakerAndEgg from "./scale_with_beaker_and_egg.svg";
import ScaleWithBeakerAndShellLessEgg from "./scale_with_beaker_and_shell_less_egg.svg";
import ScaleWithTray from "./scale_with_tray.svg";
import ScaleWithTrayAndEgg from "./scale_with_tray_and_egg.svg";
import ScaleWithTrayAndCornSyrupEgg from "./scale_with_tray_and_corn_syrup_egg.svg";
import ScaleWithTrayAndSaltWaterEgg from "./scale_with_tray_and_salt_water_egg.svg";
import ScaleWithTrayAndDIWaterEgg from "./scale_with_tray_and_di_water_egg.svg";

const Scale = {
  Scale: _Scale,
  ScaleWithBeaker,
  ScaleWithBeakerAndEgg,
  ScaleWithBeakerAndShellLessEgg,
  ScaleWithTrayAndCornSyrupEgg,
  ScaleWithTrayAndSaltWaterEgg,
  ScaleWithTrayAndDIWaterEgg,
  beaker: {
    image: ScaleWithBeaker,
    egg: {
      image: ScaleWithBeakerAndEgg,
      shellLess: {
        image: ScaleWithBeakerAndShellLessEgg,
      },
    },
  },
  tray: {
    image: ScaleWithTray,
    egg: {
      image: ScaleWithTrayAndEgg,
      egg_corn_syrup: {
        image: ScaleWithTrayAndCornSyrupEgg,
      },
      egg_salt_water: {
        image: ScaleWithTrayAndSaltWaterEgg,
      },
      egg_di_water: {
        image: ScaleWithTrayAndDIWaterEgg,
      },
    },
  },
  image: _Scale,
};

export default Scale;
